import React, {useMemo}										from 'react';

import Badge										from './Badge';
import Icon											from '../Icon';

import {useAppSelector}								from '../../../app/hooks';
import {User}										from '../../../redux/user/interface';
import {BadgeColor}									from './interface';
import {AllContract}								from '../../../redux/contracts/interface';
import {Order, OrderAddressList}							from '../../../redux/order/interface';

import img_computer									from '../../images/icon/devices/computer.svg';
import img_phone									from '../../images/icon/devices/phone.svg';
import img_tablet									from '../../images/icon/devices/tablet.svg';
import img_other									from '../../images/icon/devices/other.svg';

import './Badge.css';

const IMG_DEVICES = {
	computer: img_computer,
	phone:    img_phone,
	tablet:   img_tablet,
	other:    img_other
};

interface Props {
	userData?: User,
	contract?: AllContract,
	indexContractFunder?: number,
	order?: Order | Order[],
	addressOrder?: OrderAddressList,
	gap?: number,
	basket?: boolean,
	style?: React.CSSProperties,
	devicesId?: string[]
}

function DevicesBadges(props: Props) {
	const devices = useAppSelector(state => state.devices.data);
	const mobileLines = useAppSelector(state => state.mobileLines.data);
	const basket = useAppSelector(state => state.basket.data);

	const devicesWithLines = useMemo(() => [...devices, ...mobileLines], [devices, mobileLines]);

	function addCount(deviceType: (string | undefined), quantity: number) {
		if (deviceType === 'computer' || deviceType === 'phone' || deviceType === 'tablet')
			return deviceCount[deviceType] += quantity;
		return deviceCount.other += quantity;
	}

	const checkOrder = (order: Order) => {
		order.addressList.forEach((addressOrder) => {
			addressOrder.devices.forEach((device) => {
				if (!props.userData)
					return addCount(device.shopData?.type, device.quantity);

				const status = addressOrder.status.name;

				if (status !== 'refusedByFunder' && status !== 'refusedByValala' && status !== 'shipped' && status !== 'delivered' && status !== 'cancel')
					addCount(device.shopData?.type, device.assign.filter(e => e === props.userData?._id).length);
			});
		});
	};

	const renderBadge = (color: BadgeColor, type: 'computer' | 'phone' | 'tablet' | 'other') => {
		render.push(
			<Badge
				key={type}
				size={'sm'}
				color={color}
				text={deviceCount[type]}
				style={{paddingLeft: 3}}
			>
				<div className={'deviceBadge'}>
					<Icon
						icon={IMG_DEVICES[type]}
						iconColor={type === 'computer' ? '#000000' : undefined}
					/>
				</div>
			</Badge>
		);
	};

	if (!props.userData && !props.contract && !props.addressOrder && !props.basket && !props.order && !props.devicesId)
		return <></>;

	const deviceCount = {
		computer: 0,
		phone:    0,
		tablet:   0,
		other:    0
	};
	const render: React.ReactElement[] = [];

	if (props.addressOrder)
		props.addressOrder.devices.forEach(device => addCount(device.shopData?.type, device.quantity));
	else if (props.basket)
		basket.forEach(basketData => addCount(basketData?.device?.type, basketData.quantity));
	else if (props.order && !Array.isArray(props.order))
		checkOrder(props.order);
	else if (props.contract && 'funderList' in props.contract) {
		if (props.indexContractFunder !== undefined) {
			props.contract.funderList[props.indexContractFunder].devices.forEach((device) => {
				if (!device.device.replacement?.replaces && !device.device.data?.oldCompany?.find(f => f.contract === props.contract?._id && f.replaces))
					addCount(device.device.shopData?.type, 1);
			});
		} else {
			props.contract.funderList.forEach((funder) => {
				funder.devices.forEach((device) => {
					if (!device.device.replacement?.replaces && !device.device.data?.oldCompany?.find(f => f.contract === props.contract?._id && f.replaces))
						addCount(device.device.shopData?.type, 1);
				});
			});
		}
	} else {
		let finalList = devicesWithLines;

		if (props.devicesId)
			finalList = devicesWithLines.filter(device => props.devicesId?.some(e => device._id === e));

		if (props.order)
			props.order.forEach(checkOrder);

		finalList.forEach((device) => {
			if (!device || (props.userData && device.user !== props.userData?._id))
				return;
			if (props.contract && device.contract !== props.contract._id && device.contractNotValala !== props.contract._id)
				return;
			addCount(device.shopData?.type || device.notValalaData?.deviceType, 1);
		});
	}

	renderBadge('primary', 'computer');
	renderBadge('warning', 'phone');
	renderBadge('success', 'tablet');
	renderBadge('gray', 'other');

	return (
		<div
			className={'deviceBadgeContainer'}
			style={{
				...props.style,
				gap: props.gap
			}}
		>
			{render}
		</div>
	);
}

export default DevicesBadges;